<mat-sidenav-container class="contact-list__root container" [hasBackdrop]="true">
  <mat-sidenav class="fixed" #drawer [mode]="'over'" position="start">
    <app-organizations
      [profile]="profile() || undefined"
      (logout)="onLogout()"
      (close)="drawer.toggle()"
      (selected)="onOrganizationSelected($event)"
    ></app-organizations>
  </mat-sidenav>
  <section class="contact-list__root_logo-ctn header">
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="header__content">
          <div class="left">
            <button mat-icon-button (click)="drawer.toggle()" aria-label="Menu">
              <mat-icon>menu</mat-icon>
            </button>
            <h3>{{ currentOrganization()?.description }}</h3>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </section>
  <section class="contact-list">
    <app-dashboard-section-header
      [headerText]="'Alert Roster'"
      [hideAddButton]="true"
    >
      <div class="alert-roster__placeholder white-background-content">
        <p class="alert-roster__lead">
          Upload a roster file, map columns, reconcile contacts, then start an alert campaign.
        </p>
        <button mat-flat-button color="primary" type="button" (click)="onUploadRoster()">
          Upload roster file
        </button>
      </div>
    </app-dashboard-section-header>

    <app-dashboard-section-header
      [headerText]="patientsHeaderText()"
      (addNew)="onAddNew()"
    >
      <form [formGroup]="searchForm" class="contact-list__root__search-ctn">
        <mat-form-field class="search full-width" appearance="outline" subscriptSizing="dynamic">
          <input
            matInput
            #searchInput
            placeholder="Search..."
            formControlName="search"
          />
          @if (searchForm.get('search')?.value) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Clear search"
              (click)="clearSearch(searchInput)"
            >
              <mat-icon>backspace</mat-icon>
            </button>
          } @else {
            <mat-icon matSuffix class="search-suffix-icon" aria-hidden="true">search</mat-icon>
          }
        </mat-form-field>
      </form>
      @if (patientsLoading() !== true) {
        @if (patients().length > 0) {
          <div class="alert-roster-patients white-background-content">
            @for (p of patients(); track p.id) {
              <article
                class="alert-roster-card"
                role="link"
                tabindex="0"
                (click)="onSelectedPatient(p)"
                (keydown.enter)="onSelectedPatient(p)"
              >
                <div class="cycle-row">
                  <span class="cycle-row__when">{{ p.name }}</span>
                  <div class="cycle-row__info">
                    @if (p.phone) {
                      <p class="alert-roster-card__row">
                        <span class="alert-roster-card__label">Phone:</span>
                        <span class="alert-roster-card__value">{{ formatPhone(p.phone) }}</span>
                      </p>
                    }
                  </div>
                  <span class="cycle-row__status">
                    <mat-icon class="alert-roster-card__chevron" aria-hidden="true">chevron_right</mat-icon>
                  </span>
                </div>
              </article>
            }
          </div>
          @if (hasPreviousPage() || hasNextPage()) {
            <nav class="alert-roster__pager" aria-label="Patients pagination">
              <button
                mat-stroked-button
                type="button"
                [disabled]="!hasPreviousPage()"
                (click)="onPreviousPage()"
              >
                Previous
              </button>
              <button
                mat-stroked-button
                type="button"
                [disabled]="!hasNextPage()"
                (click)="onNextPage()"
              >
                Next
              </button>
            </nav>
          }
        } @else {
          <p class="empty-message">There are no matching records.</p>
        }
      } @else {
        <div class="loading">
          <mat-card appearance="outlined" class="place_holder">
            <mat-card-content>
              <app-skeleton
                viewBox="0 0 150 24"
                [speed]="2"
                backgroundColor="#E0DCDC"
                foregroundColor="rgba(0, 0, 0, 0.1)"
              >
                <svg:rect x="140" y="0" rx="0" ry="0" width="10px" height="9" />
                <svg:rect x="3" y="0" rx="0" ry="0" width="50%" height="9" />
                <svg:rect x="3" y="11" rx="0" ry="0" width="30%" height="9" />
              </app-skeleton>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </app-dashboard-section-header>
  </section>
</mat-sidenav-container>
